import NextSteps from 'components/Footer/NextSteps';
import Notification from 'components/Notification';
import Questions from 'components/Footer/Questions';
import * as React from 'react';
export default {
  NextSteps,
  Notification,
  Questions,
  React
};